import React from "react";
import clsx from "clsx";

import styles from "./StepTitle.module.scss";

interface Props {
  title: string;
  currentStep: number;
  totalStep: number;
  highlighted?: boolean;
  titleStepGap?: boolean;
}

export const StepTitle = ({
  title,
  currentStep,
  totalStep,
  highlighted,
  titleStepGap,
}: Props) => {
  return (
    <div
      className={clsx(
        styles.titleWrapper,
        highlighted && styles.highlightedBorder,
      )}
    >
      <p className={clsx(styles.title, highlighted && styles.highlighted)}>
        {title}
      </p>
      <p className={clsx(styles.step, titleStepGap && styles.titleStepGap)}>
        （{currentStep}/{totalStep}）
      </p>
    </div>
  );
};

export default StepTitle;
